import React from "react";
import ThemedModal from "../../utilities/ThemedModal";
import { Modal } from "react-bootstrap";
import { Button } from "../../";
import { EmailSaveDraftConfirmationModalProps } from "./types";

export const SaveDraftConfirmationModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    defaultValues,
    dialogId,
    dismiss,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<EmailSaveDraftConfirmationModalProps>) => {

    const onClose = () : void => dismiss!();

    const onDiscard = () : void => proceed!(false);

    const onSaveChanges = () : void => proceed!(true);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>Save Changes?</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <p>
                    You have made changes to this email that have not yet been saved. Are you sure you want to cancel these changes and close the window?
                    <br />
                    <br />
                    This will lose any unsaved progress!
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" variant="secondary" onClick={onDiscard}>Discard Changes</Button>
                <Button type="button" variant="primary" onClick={onSaveChanges}>Save Changes</Button>
                <Button type="button" variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};